import React from 'react';
import PropTypes from 'prop-types';
import {Row, Col, Modal, ModalHeader, ModalBody} from 'reactstrap';
import Navigation from 'components/Navigation';
import Controls from "./Controls/Controls";
import Content from "./Content/Content";
import {FormattedMessage} from "react-intl";

class Conversations extends React.Component {
    static propTypes = {
        operator: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
        adverts: PropTypes.array.isRequired,
        selectedAdvert: PropTypes.object,
        onAdvertChange: PropTypes.func.isRequired,
        onAdvertCreate: PropTypes.func.isRequired,
        profileList: PropTypes.array.isRequired,
        profile: PropTypes.object,
        contacts: PropTypes.array.isRequired,
        onContactFilterChange: PropTypes.func.isRequired,
        contactFilter: PropTypes.string,
        onSaveVoiceNote: PropTypes.func.isRequired,
        onSendSms: PropTypes.func.isRequired,
        onProfileNoteFavoutriteToggle: PropTypes.func.isRequired,
        notes: PropTypes.array.isRequired,
        onProfileNoteCreate: PropTypes.func.isRequired,
        onProfileNoteEdit: PropTypes.func.isRequired,
        onProfileTitleChange: PropTypes.func.isRequired,
        onProfileInfoChange: PropTypes.func.isRequired,
        onProfileConversationRead: PropTypes.func.isRequired,
        onProfileTitleSearchChange: PropTypes.func.isRequired,
        onAdvertEdit: PropTypes.func.isRequired,
        priceValuesVoice: PropTypes.array.isRequired,
        priceValuesSms: PropTypes.array.isRequired,
        serviceTypeValues: PropTypes.array.isRequired,
        canCreateAdvert: PropTypes.bool,
        onLoadMoreProfiles: PropTypes.func.isRequired,
        onLoadMoreContacts: PropTypes.func.isRequired,
        view: PropTypes.oneOf(['controls', 'conversation', 'notes', 'advert']),
        changeView: PropTypes.func.isRequired,
        firstAdvertCreatedModalOpened: PropTypes.bool,
        toggleFirstAdvertCreatedModal: PropTypes.func.isRequired,

    };

    render() {
        const {
            operator,
            onLogout,
            onOnlineChange,
            selectedAdvert,
            adverts,
            onAdvertCreate,
            profile,
            profileList,
            contacts,
            onContactFilterChange,
            contactFilter,
            onSaveVoiceNote,
            onSendSms,
            notes,
            onProfileNoteFavoutriteToggle,
            onProfileNoteCreate,
            onProfileInfoChange,
            onProfileTitleChange,
            onProfileConversationRead,
            onProfileTitleSearchChange,
            onAdvertEdit,
            serviceTypeValues,
            priceValuesVoice,
            priceValuesSms,
            onProfileNoteEdit,
            canCreateAdvert,
            onLoadMoreProfiles,
            onLoadMoreContacts,
            view,
            changeView,
            firstAdvertCreatedModalOpened,
            toggleFirstAdvertCreatedModal,
        } = this.props;

        return (
            <Row>
                <Col md={4} xl={3} className={"col-sidebar" + (view && view !== 'controls' ? ' d-none' : '')}>
                    <Navigation user={operator} onOnlineChange={onOnlineChange} onLogout={onLogout}/>
                    <Controls adverts={adverts} selectedAdvert={selectedAdvert}
                              onProfileTitleSearchChange={onProfileTitleSearchChange} onAdvertEdit={onAdvertEdit}
                              priceValuesVoice={priceValuesVoice} priceValuesSms={priceValuesSms} serviceTypeValues={serviceTypeValues}
                              onAdvertCreate={onAdvertCreate} selectedConversationId={profile ? profile.id : null}
                              canCreateAdvert={canCreateAdvert} onLoadMoreProfiles={onLoadMoreProfiles}
                              canHaveHappyHours={operator.happyHoursPermitted}
                    />
                </Col>
                <Content onSaveVoiceNote={onSaveVoiceNote} onContactFilterChange={onContactFilterChange}
                         contactFilter={contactFilter} profile={profile}
                         profileList={profileList} contacts={contacts} advert={selectedAdvert} onSendSms={onSendSms}
                         notes={notes} onProfileNoteFavouriteToggle={onProfileNoteFavoutriteToggle}
                         onProfileNoteCreate={onProfileNoteCreate} onProfileTitleChange={onProfileTitleChange}
                         onProfileInfoChange={onProfileInfoChange} onProfileConversationRead={onProfileConversationRead}
                         onProfileNoteEdit={onProfileNoteEdit} onLoadMoreContacts={onLoadMoreContacts}
                         view={view} changeView={changeView}
                />
                <Modal isOpen={firstAdvertCreatedModalOpened} toggle={toggleFirstAdvertCreatedModal}>
                    <ModalHeader toggle={toggleFirstAdvertCreatedModal}>
                        <FormattedMessage id="first_advert_created_modal.title" defaultMessage="Everything is ready" />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage id="first_advert_created_modal.text" defaultMessage="To accept calls, change your online status on left side of top edge of the page." />
                    </ModalBody>
                </Modal>
            </Row>
        )
    }
}

export default Conversations;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Conversations.jsx